import * as React from 'react';
import { LogoImg } from '../../Logo';
import { ContentWrapper, ContentContainer, CloseButton, EmphasizedHeader } from '../style.css';
import { Country } from '../../../common/models';
import ChineseContent from './RegionalContent/China';
import JapaneseContent from './RegionalContent/Japan';
import KoreanContent from './RegionalContent/Korea';

interface RegionalLightboxContentProps {
  basePathWeb: string;
  close: () => void;
  countryId: number;
  s3BasePath: string;
  wrapperBackground?: string;
}

interface RegionalConfig {
  content: React.ComponentType<ContentProps>;
  desktop: { heightPx: number };
  mobile: { heightPx: number };
}

interface ContentProps {
  border?: string;
  contentBackground?: string;
  contentHeight?: string;
  contentWidth?: string;
  wrapperBackground?: string;
  wrapperHeight?: string;
  wrapperWidth?: string;
}

const regionalConfigs: { [countryId: string]: RegionalConfig } = {
  [Country.china()]: { content: ChineseContent, desktop: { heightPx: 400 }, mobile: { heightPx: 480 } },
  [Country.hongKong()]: { content: ChineseContent, desktop: { heightPx: 400 }, mobile: { heightPx: 480 } },
  [Country.korea()]: { content: KoreanContent, desktop: { heightPx: 400 }, mobile: { heightPx: 480 } },
  [Country.japan()]: { content: JapaneseContent, desktop: { heightPx: 430 }, mobile: { heightPx: 530 } }
};

/* Components */
const RegionalLightboxContent: React.FunctionComponent<RegionalLightboxContentProps> = props => {
  const { countryId, close, s3BasePath, wrapperBackground } = props;
  const config = regionalConfigs[countryId.toString()];
  if (!config) {
    return null;
  }

  const {
    content,
    mobile: { heightPx: mobileHeightPx },
    desktop: { heightPx: desktopHeightPx }
  } = config;

  return (
    <ContentWrapper
      background={wrapperBackground}
      desktopHeight={`${desktopHeightPx}px`}
      mobileHeight={`${mobileHeightPx}px`}
      onClick={e => e.stopPropagation()}
    >
      <ContentContainer desktopHeight={`${desktopHeightPx - 20}px`} mobileHeight={`${mobileHeightPx - 20}px`}>
        <CloseButton onClick={close}>×</CloseButton>
        <LogoImg height="35px" margin="24px 0" s3BasePath={s3BasePath} width="90px" />
        <EmphasizedHeader fontSize="16px">WELCOME TO ITALIST!</EmphasizedHeader>
        {React.createElement(content, props as React.Attributes)}
      </ContentContainer>
    </ContentWrapper>
  );
};

export default RegionalLightboxContent;
